module.exports = __webpack_public_path__ + "7f462c840d078ed9adbacf763199e09f.svg";